export default __webpack_public_path__ + "f55cb38857d96b5e75e1d855d7029bd5.svg";